import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotComments from "./components/HotComments";
import JokesBarrage from "./components/JokesBarrage";
import MemeWall from "./components/MemeWall";
import Reactions from "./components/Reactions";
import About from "./components/About";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { faqs } from "@/mocks/guaData";

export default function Home() {
  return (
    <>
      <Navbar />

      <main>
        <Hero />
        <HotComments />
        <JokesBarrage />
        <MemeWall />
        <Reactions />
        <About />
        <Faq />
        <Contact />
      </main>

      <Footer />
      <BackToTop />

      {/* SEO 结构化数据 */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                name: "明星吃瓜·现场",
                url: "https://ytshanbei.cn/",
                description:
                  "明星吃瓜热评弹幕、表情包、神梗段子与网友反应合集平台。",
                inLanguage: "zh-CN",
              },
              {
                "@type": "FAQPage",
                mainEntity: faqs.map((f) => ({
                  "@type": "Question",
                  name: f.q,
                  acceptedAnswer: { "@type": "Answer", text: f.a },
                })),
              },
            ],
          }),
        }}
      ></script>
    </>
  );
}